/**
 * 日期格式化工具函数
 */

/**
 * 格式化日期为相对时间（今天、昨天、或具体日期）
 * @param dateStr ISO 日期字符串
 * @returns 格式化后的日期字符串
 */
export function formatRelativeDate(dateStr: string): string {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  
  // 格式化时间部分
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const timeStr = `${hours}:${minutes}`;
  
  // 判断是今天、昨天还是其他日期
  if (dateOnly.getTime() === today.getTime()) {
    return `今天 ${timeStr}`;
  } else if (dateOnly.getTime() === yesterday.getTime()) {
    return `昨天 ${timeStr}`;
  } else {
    // 其他日期，显示完整日期
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${timeStr}`;
  }
}

/**
 * 格式化完整日期时间
 * @param dateStr ISO 日期字符串
 * @returns YYYY-MM-DD HH:mm:ss 格式
 */
export function formatFullDateTime(dateStr: string): string {
  if (!dateStr) return '';
  
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      return dateStr; // 如果解析失败，返回原值
    }
    
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch (e) {
    return dateStr; // 如果解析失败，返回原值
  }
}

